function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgWinter = function SvgWinter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 481.321 481.321",
    style: {
      enableBackground: "new 0 0 481.321 481.321"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M157.027,273.72V49.648C157.027,22.224,134.795,0,107.379,0l0,0 C79.955,0,57.731,22.232,57.731,49.648v226.496c-37.312,20.312-61.464,61.736-56.4,108.224 c5.456,50.096,46.016,90.736,96.104,96.264c65.888,7.28,121.648-44.112,121.648-108.528 C219.083,328.712,193.699,291.328,157.027,273.72z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4F1F4"
    },
    d: "M132.195,304.872v-89.728c0-13.712-11.112-24.824-24.824-24.824l0,0 c-13.712,0-24.824,11.112-24.824,24.824v91.048c-26.112,10.32-44.832,35.28-45.904,64.792c-1.44,39.632,30.8,74.12,70.448,75.232 c41.04,1.152,74.664-31.776,74.664-72.552C181.763,341.64,160.987,314.504,132.195,304.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4F1F4"
    },
    d: "M123.459,71.992h-32c-4.416,0-8-3.576-8-8s3.584-8,8-8h32c4.416,0,8,3.576,8,8 S127.875,71.992,123.459,71.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4F1F4"
    },
    d: "M123.459,119.992h-32c-4.416,0-8-3.576-8-8s3.584-8,8-8h32c4.416,0,8,3.576,8,8 S127.875,119.992,123.459,119.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4F1F4"
    },
    d: "M123.459,167.992h-32c-4.416,0-8-3.576-8-8s3.584-8,8-8h32c4.416,0,8,3.576,8,8 S127.875,167.992,123.459,167.992z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M232.755,177.232c-2.048,0-4.096-0.784-5.656-2.344c-3.128-3.128-3.128-8.184,0-11.312 L338.907,51.768c3.128-3.128,8.184-3.128,11.312,0s3.128,8.184,0,11.312L238.411,174.888 C236.843,176.456,234.803,177.232,232.755,177.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M344.563,177.232c-2.048,0-4.096-0.784-5.656-2.344L227.099,63.08 c-3.128-3.128-3.128-8.184,0-11.312s8.184-3.128,11.312,0l111.816,111.816c3.128,3.128,3.128,8.184,0,11.312 C348.659,176.456,346.611,177.232,344.563,177.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M296.659,157.8V68.648l21.936-21.864c3.136-3.12,3.144-8.176,0.024-11.312 s-8.184-3.152-11.312-0.016l-10.648,10.608V33.328c0-4.424-3.584-8-8-8s-8,3.576-8,8V46.04l-10.6-10.584 c-3.136-3.12-8.2-3.136-11.32,0.016c-3.12,3.128-3.112,8.184,0.008,11.312l21.912,21.864v89.16l-21.904,21.856 c-3.128,3.128-3.136,8.184-0.008,11.312c3.12,3.136,8.184,3.136,11.32,0.016l10.592-10.584v12.92c0,4.424,3.584,8,8,8s8-3.576,8-8 v-12.944l10.648,10.608c1.56,1.56,3.6,2.336,5.648,2.336s4.104-0.784,5.664-2.352c3.12-3.136,3.112-8.192-0.024-11.312 L296.659,157.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M368.659,105.328h-13.528l9.736-10.584c2.992-3.248,2.784-8.312-0.472-11.304 c-3.248-2.992-8.32-2.784-11.304,0.48l-19.696,21.408h-90.128l-20.568-21.52c-3.056-3.2-8.12-3.312-11.312-0.256 c-3.192,3.048-3.312,8.12-0.256,11.304l10.008,10.472h-12.48c-4.416,0-8,3.576-8,8s3.584,8,8,8h12.456l-11.032,10.992 c-3.136,3.128-3.144,8.184-0.024,11.32c1.56,1.568,3.616,2.352,5.664,2.352c2.04,0,4.088-0.776,5.648-2.328l22.424-22.336h89.656 l20.888,22.152c1.576,1.672,3.696,2.512,5.824,2.512c1.968,0,3.944-0.72,5.488-2.176c3.216-3.032,3.36-8.096,0.336-11.304 l-10.544-11.184h13.216c4.416,0,8-3.576,8-8S373.075,105.328,368.659,105.328z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E4F1F4"
    },
    cx: 289.059,
    cy: 112.904,
    r: 29.824
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M289.083,150.736c-20.856,0-37.824-16.968-37.824-37.832s16.968-37.832,37.824-37.832 c20.856,0,37.832,16.968,37.832,37.832S309.939,150.736,289.083,150.736z M289.083,91.08c-12.032,0-21.824,9.792-21.824,21.832 c0,12.04,9.792,21.832,21.824,21.832s21.832-9.792,21.832-21.832S301.115,91.08,289.083,91.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M336.755,401.232c-2.048,0-4.096-0.784-5.656-2.344c-3.128-3.128-3.128-8.184,0-11.312 L442.915,275.76c3.128-3.128,8.184-3.128,11.312,0s3.128,8.184,0,11.312L342.411,398.888 C340.843,400.456,338.803,401.232,336.755,401.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M448.563,401.232c-2.048,0-4.096-0.784-5.656-2.344L331.099,287.08 c-3.128-3.128-3.128-8.184,0-11.312s8.184-3.128,11.312,0l111.816,111.816c3.128,3.128,3.128,8.184,0,11.312 C452.659,400.456,450.611,401.232,448.563,401.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M400.659,381.8v-89.152l21.936-21.864c3.136-3.12,3.144-8.176,0.024-11.312 c-3.12-3.136-8.192-3.152-11.312-0.016l-10.648,10.608v-12.736c0-4.424-3.584-8-8-8s-8,3.576-8,8v12.712l-10.6-10.584 c-3.136-3.12-8.2-3.128-11.32,0.016c-3.12,3.128-3.112,8.184,0.008,11.312l21.912,21.864v89.16l-21.904,21.856 c-3.128,3.128-3.136,8.184-0.008,11.312c3.12,3.144,8.184,3.128,11.32,0.016l10.592-10.584v12.92c0,4.424,3.584,8,8,8s8-3.576,8-8 v-12.944l10.648,10.608c1.56,1.56,3.6,2.336,5.648,2.336s4.104-0.784,5.664-2.352c3.12-3.136,3.112-8.192-0.024-11.312 L400.659,381.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M472.659,329.328h-13.528l9.736-10.584c2.992-3.248,2.784-8.312-0.472-11.304 c-3.248-2.992-8.328-2.784-11.304,0.48l-19.696,21.408h-90.128l-20.568-21.52c-3.056-3.208-8.12-3.312-11.312-0.256 c-3.192,3.048-3.312,8.12-0.256,11.304l10.008,10.472h-12.48c-4.416,0-8,3.576-8,8s3.584,8,8,8h12.456l-11.032,10.992 c-3.136,3.128-3.144,8.184-0.024,11.32c1.56,1.568,3.616,2.352,5.664,2.352c2.04,0,4.088-0.776,5.648-2.328l22.424-22.336h89.656 l20.888,22.152c1.576,1.672,3.696,2.512,5.824,2.512c1.968,0,3.944-0.72,5.488-2.176c3.216-3.032,3.36-8.096,0.336-11.304 l-10.544-11.184h13.216c4.416,0,8-3.576,8-8S477.075,329.328,472.659,329.328z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E4F1F4"
    },
    cx: 393.059,
    cy: 336.904,
    r: 29.824
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M393.083,374.736c-20.856,0-37.824-16.968-37.824-37.832s16.968-37.832,37.824-37.832 c20.856,0,37.832,16.968,37.832,37.832S413.939,374.736,393.083,374.736z M393.083,315.08c-12.032,0-21.824,9.792-21.824,21.832 s9.792,21.832,21.824,21.832s21.832-9.792,21.832-21.832S405.115,315.08,393.083,315.08z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWinter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/winter.19c88f05.svg";
export { ForwardRef as ReactComponent };